module.exports = __webpack_public_path__ + "static/img/f1.be1507b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/pit/tremor/f1.png
// module id = HFcn
// module chunks = 0